
import { defineComponent } from 'vue';
import {Chart} from 'chart.js';

export default defineComponent({
  props: {
    data: Array,
    timestamp: Array,
  },
  data() {
    return {
      myChart: (Chart as unknown) as Chart,
    };
  },
  methods: {
    createChart(chartId: string) {
      this.myChart = new Chart(chartId, {
        type: 'line',
        data: {
          labels: this.timestamp as Array<string>,
          datasets: [
            {
              label: 'VOMAX',
              data: this.data as Array<number>,
              borderColor: '#71B2D9',
              lineTension: 0,
              borderWidth: 3,
              pointRadius: 1,
            },
          ],
        },
        options: {
          events: [],
          animation: {
            duration: 0,
          },
          legend: {
            display: false,
          },
          responsive: true,

          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                gridLines: {
                  color: 'rgba(113, 178, 217, 0.2)',
                },
              },
            ],
          },
        },
      });
    },
  },
  mounted() {
    this.createChart('oxygen');
  },
  watch: {
    data() {
      this.myChart.destroy();
      this.createChart('oxygen');
    },
    timestamp() {
      this.myChart.destroy();
      this.createChart('oxygen');
    },
  },
});
